import styled from 'styled-components'
import { GridColumn } from '../../types/grid.types'
import { CellAlign, resolveAlign } from '../../utils/align'
import GridCellRenderer from '../cells/GridCellRenderer'

export interface GridCellProps<T> {
  column: GridColumn<T>
  row: T
}

const alignToText: Record<CellAlign, string> = {
  start: 'start',
  end: 'end',
  center: 'center',
}

export const GridCell = <T,>({ column, row }: GridCellProps<T>) => (
  <Td $align={resolveAlign(column)}>
    <GridCellRenderer column={column} row={row} />
  </Td>
)

export default GridCell

const Td = styled.td<{ $align: CellAlign }>`
  padding: 0 16px;
  height: 52px;
  font-size: ${({ theme }) => theme.text.lg};
  color: ${({ theme }) => theme.colors.ink2};
  border-bottom: 1px solid ${({ theme }) => theme.colors.line2};
  white-space: nowrap;
  vertical-align: middle;
  text-align: ${({ $align }) => alignToText[$align]};
`
